export default "__VITE_ASSET__CXZQoo$h__"